<template>
  <svg width="24" height="24" viewBox="0 0 24 24">
    <path
      d="M12.005 21C16.925 21 21 16.925 21 11.995 21 7.075 16.915 3 11.995 3 7.075 3 3 7.075 3 11.995 3 16.925 7.085 21 12.005 21zm-.01-1.688A7.28 7.28 0 0 1 4.688 12a7.278 7.278 0 0 1 7.298-7.313A7.307 7.307 0 0 1 19.312 12a7.282 7.282 0 0 1-7.317 7.313zm-.009-3.149c.483 0 .77-.334.77-.854v-2.543h2.693c.51 0 .854-.279.854-.752 0-.492-.325-.78-.854-.78h-2.692V8.542c0-.52-.288-.854-.77-.854-.484 0-.762.353-.762.854v2.692H8.542c-.52 0-.863.288-.863.78 0 .473.362.752.863.752h2.683v2.543c0 .502.278.854.761.854z"
      fill="#0071BB"
      fill-rule="evenodd"
    />
  </svg>
</template>
